import { TTeaserBlockType } from '../../types/teaser';
import { ThunkAction } from 'redux-thunk';
import { IContext, IState } from '../../store';
import { selectOffer } from '../../components/CostEstimate/selectors/selectOffer';
import { selectSoprApi } from '../../components/CostEstimate/selectors/selectSoprApi';
import { selectTrackingUser } from '../../components/CostEstimate/selectors/selectTrackingUser';
import { trackBannerShow } from '../../components/demand/utils/tracking';

export const trackInViewPort = (blockType: TTeaserBlockType, visible: boolean): ThunkAction<void, IState, IContext> => {
  return (dispatch, getState) => {
    if (!visible) {
      return;
    }

    const state = getState();

    const { id: offerId } = selectOffer(state);
    const soprApi = selectSoprApi(state);
    const { userId, abGroup } = selectTrackingUser(state);

    trackBannerShow({
      abGroup,
      userId,
      soprApi,
      offerId,
      blockType,
    });
  };
};
